export const MYGOORU_AI_CONTEXT_TYPE = 'mygooru-ai';
export const INIT_ACTION_TYPE = 'init';
export const GOOGLE_PDF = `https://docs.google.com/gview?embedded=true&url=`;
export const NEW_USER = 'newUser';
export const FULLSCREEN_STATUS = {
    ENTER: 'enterFullScreen',
    EXIT: 'exitFullScreen'
};
export const USERCATEGORY = {
    STUDENT: 'student',
    TEACHER: 'teacher'
}

export const LOGINTYPE = {
    SERVER2SERVER: 'server2server',
    CREDENTIAL: 'credential',
    SECRET_KEY: 'myg-learn-widget'
}

